
import theme from '@/assets/theme.scss';
import fundamentalSheetConstants from '@/constants/fundamental.constants';

const {
    fundamentalFormat,
    tabConstants,
} = fundamentalSheetConstants;

export default {
    name: "FundChart",

    props: {
        tabKey: {
            type: Number,
            default: 0,
        },
        data: {
            type: Object,
            default: () => {}
        },
        selectedTimeFrame: {
            type: Number,
            default: 0,
        },
        chartSections: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            chartKeyConfigs: []
        }
    },

    computed: {
        chartData() {
            if (Object.keys(this.data).length === 0) {
                return []
            }
            //handle for earnings tab
            if (this.tabKey === this.tabConstants.earnings) {
                return this.chartSections.map((section, index) => {
                    const dataColumn = this.chartKeyConfigs[index].filter(e => e.show)
                    const result = [['Quarter', ...dataColumn.map(e => this.$t(e.text))]]
                    //reverse year order
                    for (let i = (this.selectedTimeFrame === -1 ? this.data.date.length : this.calculateNumberOfDateEarnings()) - 1; i >= 0 ; i--) {
                        const valueArray = []
                        for (const key of dataColumn) {
                            valueArray.push(this.convertStringToFloat(this.data[key.value][i]))
                        }
                        result.push([this.data.date[i].toString(), ...valueArray])
                    }
                    return result
                })
            }
            return this.chartSections.map((section, index) => {
                const dataColumn = this.chartKeyConfigs[index].filter(e => e.show)
                const result = [['Year', ...dataColumn.map(e => this.$t(e.text))]]
                //reverse year order
                for (let i = (this.selectedTimeFrame == -1 ? this.data.calendarYear.length : this.selectedTimeFrame) - 1; i >= 0 ; i--) {
                    const valueArray = []
                    for (const key of dataColumn) {
                        if (key.format === fundamentalFormat.relativeValue) {
                            const value = this.convertStringToFloat(this.data[key.value][i])
                            valueArray.push({v: value, f: `${value} %`})
                        } else {
                            valueArray.push(this.convertStringToFloat(this.data[key.value][i]))
                        }
                    }
                    result.push([this.data.calendarYear?.[i].toString(), ...valueArray])
                }
                return result
            })
        },
        chartOptions() {
            return this.chartSections.map((section, index) => {
                let numberOfBars = 0
                const dataColumn = this.chartKeyConfigs[index].filter(e => e.show)
                const series = dataColumn.reduce(
                    (acc, cur, index) => {
                        const isBarChart = cur.type ? cur.type === 'bar' : cur.format ===  fundamentalFormat.absoluteCurrency
                        if (isBarChart) {
                            numberOfBars++
                        }
                        return { ...acc, [index]: isBarChart ? { type: "bar", targetAxisIndex: 0 } : { type: "area", targetAxisIndex: 1, curveType: "function" } }
                    },
                    {},
                );
                const colors = this.chartKeyConfigs[index].reduce(
                    (acc, cur, index) => {
                        if (cur.show) {
                            return [ ...acc, this.colors[index] ]
                        }
                        return acc
                    },
                    [],
                );
                const bar = {groupWidth: numberOfBars > 1 ? '60' : '30'}
                const chartArea = {
                    height: '100%',
                    width: '100%',
                    top: 24,
                    left: numberOfBars == 0 ? 0 : 48,
                    right: 48,
                    bottom: 32,
                }
                return { ...this.baseOptions, series, colors ,chartArea, bar }
            })
        },
        colors() {
            return this.$vuetify.theme.dark ? this.darkColors : this.lightColors
        }
    },

    watch: {
        chartSections: {
            handler(sections) {
                this.chartKeyConfigs = sections.map(section => {
                    return section.chartKeys.map(key => {
                        return {...key, show: true }
                    })
                });
            },
            immediate: true
        },
    },

    created() {
        this.tabConstants = tabConstants
        this.lightColors = [...Array(14).keys()].map(i => theme[`financial-indicator-chart-light-${i + 1}`])
        this.darkColors = [...Array(14).keys()].map(i => theme[`financial-indicator-chart-dark-${i + 1}`])
        this.baseOptions = {
            "intervals" : { "style" : "area", "color" : "#D49464" },
            height: '300',
            width: '100%',
            backgroundColor: 'transparent',
            fontName:'Albert Sans',
            fontSize: '12',
            seriesType: 'bars',
            legend: 'none',
            vAxes: {
                0: {
                    format: 'short'
                },
                1: {
                    format: 'short'
                },
            }
        }
    },

    methods: {
        convertStringToFloat(string) {
            const replacedString = string.replace(/[. %]/g, '') .replaceAll(',', '.')
            return parseFloat(replacedString)
        },
        toggleShow(sectionIndex , badgeIndex) {
            const numbersOfShowedData = this.chartKeyConfigs[sectionIndex].filter(e => e.show).length
            if (numbersOfShowedData === 1 && this.chartKeyConfigs[sectionIndex][badgeIndex].show) {
                return
            }
            this.chartKeyConfigs[sectionIndex][badgeIndex].show = !this.chartKeyConfigs[sectionIndex][badgeIndex].show
        },
        calculateNumberOfDateEarnings() {
            let numberOfColumns = 0
            const years = new Set()
            for (const date of this.data.date) {
                years.add(date?.split('-')[0])
                if (years.size > this.selectedTimeFrame) {
                    break;
                }
                numberOfColumns++
            }
            return numberOfColumns
        }
    },
}
